export default __webpack_public_path__ + "static/media/Hockey Stadium, Shahabad6.843fecde.jpg";